import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { RateLimitService } from '../../services/rate-limit.service';
import { AppFilter } from '@app/shared/models';

interface IAddGlobalRateLimitContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-add-global-ratelimit-profile',
  templateUrl: './add-global-ratelimit.component.html',
  styleUrls: ['./add-global-ratelimit.component.scss'],
})
export class AddGlobalRateLimitModalComponent implements OnInit {
  globalRateLimitForm!: FormGroup;
  pending: boolean;
  success: string;
  error: string;
  countriesLoading = false;
  countries: any[] = [];

  constructor(
    public modal: SuiModal<IAddGlobalRateLimitContext, any, any>,
    private fb: FormBuilder,
    private rateLimitService: RateLimitService
  ) {
    this.getGlobalRateLimitSettings();
    this.globalRateLimitForm = fb.group({
      country: ['', Validators.required],
      requests: ['', Validators.required],
      timeInterval: ['', Validators.required],
      response: ['', Validators.required],
    });

    if (modal.context.data.operation === 'edit') {
      this.globalRateLimitForm.patchValue({
        country: modal.context.data.country,
        requests: modal.context.data.quota,
        timeInterval: modal.context.data.interval,
        response: modal.context.data.responseMessage,
      });
    }
  }

  add() {
    this.pending = true;
    let body = {
      country: this.globalRateLimitForm.value.country,
      responseMessage: this.globalRateLimitForm.value.response,
      quota: Number(this.globalRateLimitForm.value.requests),
      interval: Number(this.globalRateLimitForm.value.timeInterval),
    };

    if (this.modal.context.data.operation === 'edit') {
      this.rateLimitService
        .editGlobalRateLimitSetting(
          body,
          this.modal.context.data.rateLimitCountryId
        )
        .subscribe(
          (res) => {
            this.success = 'Edited Successfully';
            setTimeout(() => {
              this.modal.approve(undefined);
            }, 1500);
            this.pending = false;
          },
          (error) => {
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error.error
              ? error.error.error
              : error.error
              ? error.error
              : error.message
              ? error.message
              : error;
            this.pending = false;
          }
        );
    } else {
      this.rateLimitService.addGlobalRateLimitSetting(body).subscribe(
        (res) => {
          this.success = 'Added Successfully';
          this.pending = false;
          setTimeout(() => {
            this.modal.approve(undefined);
          }, 1500);
        },
        (error) => {
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error.message
            ? error.message
            : error;
          this.pending = false;
        }
      );
    }
  }

  getCountries() {
    this.countriesLoading = true;
    this.rateLimitService.getCountries().subscribe(
      (res: any) => {
        for (let i = 0; i < res.rows.length; i++) {
          let isSelected = false;

          for (let j = 0; j < this.globalRateLimits.length; j++) {
            if (res.rows[i].countryName === this.globalRateLimits[j].country) {
              isSelected = true;
              break;
            }
          }

          if (this.modal.context.data.operation === 'edit') {
            if (
              isSelected &&
              this.modal.context.data.country === res.rows[i].countryName
            ) {
              this.countries.push(res.rows[i]);
            } else {
              if (!isSelected) {
                this.countries.push(res.rows[i]);
              }
            }
          } else {
            if (!isSelected) {
              this.countries.push(res.rows[i]);
            }
          }
        }

        this.countries.reverse();
        this.countriesLoading = false;
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
        this.countriesLoading = false;
      }
    );
  }

  globalRateLimits: any[] = [];
  globalRateLimitLoading = false;

  getGlobalRateLimitSettings() {
    let filter = new AppFilter({ rows: 1000 });
    this.globalRateLimitLoading = true;
    this.rateLimitService.getGlobalRateLimitSettings(filter).subscribe(
      (res: any) => {
        this.globalRateLimits = res.rows;
        this.globalRateLimitLoading = false;
        this.getCountries();
      },
      (error) => {
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error.error
          ? error.error.error
          : error.error
          ? error.error
          : error.message
          ? error.message
          : error;
        this.globalRateLimitLoading = false;
      }
    );
  }

  ngOnInit(): void {
    this.globalRateLimitForm.valueChanges.subscribe((changes) => {
      if (changes?.timeInterval) {
        if (!isNaN(Number(changes.timeInterval))) {
          if (changes.timeInterval < 1) {
            this.globalRateLimitForm.patchValue({
              timeInterval: 1,
            });
          }
        } else {
          this.globalRateLimitForm.patchValue({
            timeInterval: '',
          });
        }
      }
    });
  }
}

export class AddGlobalRateLimitModal extends ComponentModalConfig<
  IAddGlobalRateLimitContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Mini) {
    super(AddGlobalRateLimitModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
